import { render, staticRenderFns } from "./Loading.vue?vue&type=template&id=b9b3a422&scoped=true"
var script = {}
import style0 from "./Loading.vue?vue&type=style&index=0&id=b9b3a422&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9b3a422",
  null
  
)

export default component.exports